
import React from "react";
import { useTranslation } from "react-i18next";
import { List } from "semantic-ui-react";

export default function GeneralRateCell(props) {
    const { t } = useTranslation();
    return (
      <>
        <List size="large">
          <List.Item className="text-[18px]">
              <List.Icon name='dollar' color='blue' />
              <List.Content className='pl-[5px]'>
                <List.Header >{props.client}</List.Header>
                <List.Description>{t("general_client")}</List.Description>
              </List.Content>
          </List.Item>
          <br></br>
           <List.Item>
              <List.Icon name='dollar' color='blue' />
              <List.Content style={{paddingLeft: "12px"}}>
                <List.Header>{props.operator}</List.Header>
                <List.Description>{t("operator")}</List.Description>
              </List.Content>
          </List.Item>         
        </List>
      </>
    );
  }
  